<template>
    <footer class="g-s-a-w">
        <div class="footer">

            <div class="f-part">
                <ul>
                    <div class="t">Product & Services</div>
                    <li>Domestic Services</li>
                    <li>Global Services</li>
                    <li>Value-added Services</li>
                    <li>Logistics Services</li>
                </ul>
                <ul>
                    <div class="t">Industry Solving Solutions</div>
                    <li>Warehousing Capability</li>
                    <li>Logistics Finance</li>
                    <li>Logistics Services Industry Solution</li>
                    <li>Logistics Services Module Solution</li>

                    <li>Cases of E-commerce Platform Cooperation</li>
                </ul>

                <ul>
                    <div class="t">Convenience Services</div>
                    <li>Covenience Services</li>
                    <li>Shopping Section</li>
                    <li>Agriculture Cooperated Section</li>
                </ul>

                <ul>
                    <div class="t">Smart Logistics</div>
                    <li>UAVs</li>
                    <li>AGV Processing Center</li>
                    <li>Self-Driving Trucks</li>

                    <li>Delivery Unmanned Vehicle</li>
                </ul>

                <ul>
                    <div class="t">Services Support</div>

                    <li>Shipping</li>
                    <li>Track and Trace</li>
                    <li>Rates & Transit Time</li>
                    <li>Prohibitions</li>
                    <li>Services Points</li>

                    <li>For More Inquiry</li>
                </ul>

                <ul>
                    <div class="t">About Us</div>
                    <li>About Company</li>
                    <li>News</li>
                    <li>Development</li>
                    <li>Promotion Sector</li>
                </ul>

                <ul>
                    <div class="t" style="text-align:center;">Contact Us</div>
                    <div class="contact">
                        <div class="div_css4" @mouseover="hover = true" @mouseleave="hover = false"
                            :class="{ active: hover }" style="cursor: pointer;">
                            <el-tooltip content="Top center" placement="top" effect="light" popper-class="testtooltip">
                                <span><img v-lazy="img[0]" /></span>
                                <div slot="content">
                                    <p class="text" style="margin-bottom: 5px;text-align: center;font-size: 13px;">
                                        扫码关注微信公众号</p>
                                    <img class="img_scs"
                                        src="../../../assets/english-images/footer-img/gongzhonghao.png" alt="" />
                                </div>
                            </el-tooltip>
                        </div>
                        <div class="div_css1" @mouseover="hover2 = true" @mouseleave="hover2 = false"
                            :class="{ active: hover2 }" style="cursor: pointer;">
                            <img v-lazy="img[2]" class="touch-img" @click="Subcustomer" />
                        </div>

                        <div class="div_css1" @mouseover="hover3 = true" @mouseleave="hover3 = false"
                            :class="{ active: hover3 }" style="cursor: pointer;">
                            <el-tooltip content="Top center" placement="top" effect="light" popper-class="testtooltip">
                                <span><img v-lazy="img[3]" /></span>
                                <div slot="content">
                                    <p class="text" style="margin-bottom: 5px;font-size: 13px;">扫码下载邮政EMSAPP</p>
                                    <img class="img_scsEms" src="../../../assets/english-images/footer-img/er_phon.png"
                                        alt="" style="width: 128px;height: 128px;" />
                                </div>
                            </el-tooltip>
                        </div>

                    </div>
                    <div class="tel" style="margin-top: 34px;font-size: 12px;color:rgba(255,255,255,0.58)">
                        <img v-lazy="img[5]" style="width: 130px;display: block;margin-bottom: 8px;" /> Customer Service
                        Number
                    </div>
                    <div class="logo" style="margin-top: 33px;">
                        <img v-lazy="img[6]" style="width: 140px;" />
                    </div>
                    <li class="t" style="margin: 10px 0 0;" @click="$router.push('/ContactChinaPostalAirlines')">Contact China Postal Airlines</li>
                </ul>

                <ul>
                    <div class="t">Featured Products</div>
                    <div
                        style="text-align: center;color: rgba(255,255,255,0.67);font-size: 12px;display: flex;flex-direction:column;align-items:center;">
                        <img v-lazy="img[7]"
                            style="width: 60px;height: 60px;display: block;margin-bottom: 12px;" />Fresh Express
                    </div>
                </ul>
            </div>

            <ul class="links">
                <li>Friendly Links：</li>
                <li>
                    <a href="http://www.chinapost.com.cn/" target="_blank" class="cursor_style">China Post Group</a>
                </li>
                <li class="cursor_style">
                    <a href="https://www.chinapost-life.com/" target="_blank" class="cursor_style">China Post
                        Insurance</a>
                </li>
                <li class="cursor_style">
                    <a href="http://www.cnpsec.com.cn/main/index.html" target="_blank" class="cursor_style">China Post
                        Securities</a>
                </li>
                <li class="cursor_style">
                    <a href="http://cpcm.chinapost.com.cn/html1/folder/190686/6789-1.htm" target="_blank"
                        class="cursor_style">China Post Capital Management Co., Ltd</a>
                </li>
                <li class="cursor_style">
                    <a href="http://www.psbc.com/cn/index.html" target="_blank" class="cursor_style">Postal Savings Bank
                        of China</a>
                </li>
            </ul>

            <div class="icp">
                <p class="t">
                    <span style="margin-right: 48px;">
                        2020 China Post Express Logistics Co., LTD     Copyright Reserve         	
                        <a href="https://beian.miit.gov.cn/" target="_blank" class="cursor_style1"> Beijing ICP
                            No.14043423</a>
                    </span>

                    <a @click="tiaoyemain('privacy')" target="_blank" class="cursor_style1">Privacy Policy</a>
                    <font style="margin: 0 5px;">|</font>
                    <a target="_blank" @click="tiaoyemain('law')" class="cursor_style1">Legal Statement</a>
                </p>
                <p class="b">
                    <img v-lazy="img[8]" style="width: 92px;height: 35px;margin-right: 20px;" />
                    <img v-lazy="img[9]" style="width: 20px;height: 22px;margin-right: 5px;" />
                    <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010202010863" rel="noreferrer"
                        target="_blank" class="cursor_style1">京公网安备11010202010863</a>
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
import moment from "moment";
let Base64 = require('js-base64').Base64
export default {
    name: "Botfooter",
    data() {
        return {
            img: [
                require('../../../assets/english-images/footer-img/wx.png'),
                require('../../../assets/english-images/footer-img/gongzhonghao.png'),
                require('../../../assets/english-images/footer-img/i-o-sss.png'),
                require('../../../assets/english-images/footer-img/sj.png'),
                require('../../../assets/english-images/footer-img/er_phon.png'),
                require('../../../assets/english-images/footer-img/telephone.png'),
                require('../../../assets/english-images/footer-img/ems-logo.png'),
                require('../../../assets/english-images/footer-img/er.png'),
                require('../../../assets/english-images/footer-img/site-se.png'),
                require('../../../assets/english-images/footer-img/polic-badge.png')
            ],
            hover: false,
            hover2: false,
            hover3: false,
            loginTimer: null,
            loginTimerT: null,
            num: "",
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.num = localStorage.getItem("num");
            if (this.num == "1") {
            } else if (this.num == "2") {
                this.loginTimerOutT();
            }
        },
        tiaoyemain(main) {
            this.$router.push({
                name: main,
            });
        },

        routerLinkDomestic(domestic) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: domestic,
                }).href
            } else {
                this.$router.push({
                    name: domestic,
                });
            }

        },

        routerLinkInternational(international) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: international,
                }).href
            } else {
                this.$router.push({
                    name: international,
                });
            }

        },

        routerLinkAddservices(addservices) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: addservices,
                }).href
            } else {
                this.$router.push({
                    name: addservices,
                });
            }

        },

        routerLinkcapabil(main) {
            this.$router.push({
                name: main,
            });
        },

        // 		仓储业务能力
        routercapability(business_capability) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: business_capability,
                }).href
            } else {
                this.$router.push({
                    name: business_capability,
                });
            }
            //      console.log('底部菜单栏开始')
            //      console.log(business_capability)
            //      console.log(this.$route.name)
            //      console.log(window.parent.location.href)
            //      console.log('底部菜单栏结束')

        },
        // 		供应链

        supplyChain(supply_chain) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: supply_chain,
                }).href
            } else {
                this.$router.push({
                    name: supply_chain,
                });
            }

        },

        //物流行业解决方案
        routerlogisticsIndustry(logistics_industry_solutions) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: logistics_industry_solutions,
                }).href
            } else {
                this.$router.push({
                    name: logistics_industry_solutions,
                });
            }

        },

        //物流服务模块解决方案
        routerlogisticsModule(logistics_service_module_solution) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: logistics_service_module_solution,
                }).href
            } else {
                this.$router.push({
                    name: logistics_service_module_solution,
                });
            }

        },

        //商务专递合作案例
        businessExpressCooperationCase(business_express_cooperation_case) {

            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: business_express_cooperation_case,
                }).href
            } else {
                this.$router.push({
                    name: business_express_cooperation_case,
                });
            }

        },

        Subcustomer() {
            let customer = {
                value: {
                    phone: localStorage.getItem("phone"),
                },
            };
            this.$axios
                .post("/customerOnline/getCustomeOnline", customer)
                .then((res) => {
                    this.valueData = res.value;
                    this.channelData = res.value.channel;
                    this.phoneNumberData = res.value.phoneNumber;
                    this.protocolData = res.value.protocol;
                    this.tenantIdData = res.value.tenantId;

                    window.open(
                        `${this.protocolData}?tenantId=${this.tenantIdData}&channel=${this.channelData}&phoneNumber=${this.phoneNumberData}`
                    );
                    //不要删
                    // window.open(`http://211.156.193.157:9101/imcloud/static/lead.html?tenantId=${this.tenantIdData}&channel=${this.channelData}&phoneNumber=${this.phoneNumberData}`);
                })
                .catch((err) => { });
        },

        routere_commerce(e_commerce_platform) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: e_commerce_platform,
                }).href
            } else {
                this.$router.push({
                    name: e_commerce_platform,
                });
            }

        },

        toLog() {
            if (localStorage.getItem("sta_tus") == "false") {
                // 没有登录
                // console.log("没有登录");
                this.loginTimerOut();
                window.open("/pc/main/new/#/order/v2/index");
            } else {

                window.open("/pc/main/new/#/order/v2/index");
            }

            var Traffic = {
                value: {
                    ip: returnCitySN['cip'],
                    area: returnCitySN['cname'],
                    cookies: this.$cookies.get("ecun"),
                    modelPath: 'pc/order/product',
                    modelName: Base64.encode('我要寄件'),
                    createData: moment().format("YYYY-MM-DD HH:mm:ss"),
                    onlineTime: '',
                    phonePcFlag: this.$store.state.message
                },
            };
            this.$axios
                .post("/userTrafficStatistics/getUserTrafficStatistics", Traffic)
                .then((res) => {

                })
                .catch((err) => {

                });

        },
        loginTimerOut() {
            this.loginTimer = setTimeout(() => {
                localStorage.setItem("num", "2");
                this.$router.go(0);
            }, 10000)
        },
        loginTimerOutT() {
            this.loginTimerT = setTimeout(() => {
                localStorage.setItem("num", "1");
                this.$router.go(0);
            }, 20000)
        },
        routerLink5(convenient_service) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: convenient_service,
                }).href
            } else {
                this.$router.push({
                    name: convenient_service,
                });
            }
        },
        routerLink6(huinong_district) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: huinong_district,
                }).href
            } else {
                this.$router.push({
                    name: huinong_district,
                });
            }
        },
        routerLink7(shopping_area) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: shopping_area,
                }).href
            } else {
                this.$router.push({
                    name: shopping_area,
                });
            }
        },

        // 无人机
        routerdrone(drone) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: drone,
                }).href
            } else {
                this.$router.push({
                    name: drone,
                });
            }
        },
        // AGV处理中心
        routeragvproce(agvprocessingcenter) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: agvprocessingcenter,
                }).href
            } else {
                this.$router.push({
                    name: agvprocessingcenter,
                });
            }
        },
        // 自动驾驶货车
        routerauto(autonomoustruck) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: autonomoustruck,
                }).href
            } else {
                this.$router.push({
                    name: autonomoustruck,
                });
            }
        },

        // 末端投递无人车
        routerend(enddeliveryunmanned) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: enddeliveryunmanned,
                }).href
            } else {
                this.$router.push({
                    name: enddeliveryunmanned,
                });
            }
        },

        //服务支持
        //我要寄件
        reuserviceSupport(services_support) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: services_support,
                }).href
            } else {
                this.$router.push({
                    name: services_support,
                });
            }

        },
        routerqueryLogistics(queryList) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: queryList,
                }).href
            } else {
                this.$router.push({
                    name: queryList,
                });
            }

        },
        //合作咨询
        cooperativeConsultation(cooperative_consultation) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: cooperative_consultation,
                }).href
            } else {
                this.$router.push({
                    name: cooperative_consultation,
                });
            }

        },
        //运费时效
        freightPrescription(freight_prescription) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: freight_prescription,
                }).href
            } else {
                this.$router.push({
                    name: freight_prescription,
                });
            }
        },
        //禁寄物品
        routerTaboo_items(Taboo_items) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: Taboo_items,
                }).href
            } else {
                this.$router.push({
                    name: Taboo_items,
                });
            }
        },
        //网点查询
        routernetwork(outlet_inquiry) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: outlet_inquiry,
                }).href
            } else {
                this.$router.push({
                    name: outlet_inquiry,
                });
            }
        },

        //		关于我们
        //		公司介绍
        routercompany(companyintroduction) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: companyintroduction,
                }).href
            } else {
                this.$router.push({
                    name: companyintroduction,
                });
            }
        },
        //		新闻咨询
        routernews(newsandinformation) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: newsandinformation,
                }).href
            } else {
                this.$router.push({
                    name: newsandinformation,
                });
            }
        },
        //		发展历程
        routerdeve(developmentcourse) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: developmentcourse,
                }).href
            } else {
                this.$router.push({
                    name: developmentcourse,
                });
            }
        },
        //		推广专区
        routerpromotion(promotionzone) {
            if (this.$route.name == 'otherFooter') {
                window.parent.location.href = location.origin + this.$router.resolve({
                    name: promotionzone,
                }).href
            } else {
                this.$router.push({
                    name: promotionzone,
                });
            }

        },

    },
}
</script>
<style>
.el-tooltip__popper[x-placement^="top"] {
    margin-bottom: 35px;
}

.el-tooltip__popper .popper__arrow {
    border-bottom-color: white !important;
    border-top-color: white !important;
}

.testtooltip {
    z-index: 1;
    background: white !important;
    border: 1px #efefef solid !important;
    border-radius: 11px;
}
</style>
<style lang="scss" scoped>
@import "../../../assets/css/english-css/footer/bottom-menu.scss";

.footer {
    width: 100%;
    margin: 0 auto;
}
</style>